import { Inject, Options, Vue } from "vue-property-decorator";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import { TrustAPI } from "@/shared/modules/trust-api";
import { SuburbStatePostcode } from "@/shared/modules/typescript-trustapi-client/models";
import PostcodeSearch from "@/shared/components/postcodeSearch/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    PostcodeSearch,
  }
})
export default class UpdateEeModal extends Vue {
  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private externalExaminer: any = {};
  private submitPressed = false;
  private suburbStatePostcode: SuburbStatePostcode = {};

  private isLoading = false;
  private isSaving = false;

  private closeModal() {
    this.$emit('close');
  }

  mounted(): void {
    this.loadEEdata();
  }

  private loadEEdata() {
    this.isLoading = true;
    this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerGetExternalExaminerDetailsGet()
      .then((res: any) => {
        this.externalExaminer = res.data.data;
        this.suburbStatePostcode = {
          suburbName: this.externalExaminer.suburb,
          postcode: this.externalExaminer.postCode,
          stateName: this.externalExaminer.state,
          stateCode: this.externalExaminer.state,
        }
        this.isLoading = false;
      })
      .catch((err: any) => {
        this.isLoading = false;
        this.ai.trackException(err);
      });

  }

  get suburbError(): boolean {
    return this.submitPressed && !this.suburbStatePostcode?.postcode;
  }

  private updateSuburb(s: SuburbStatePostcode) {
    // this.suburbStatePostcode = s;
    this.externalExaminer.suburb = s.suburbName;
    this.externalExaminer.postCode = s.postcode;
    this.externalExaminer.state = s.stateName;
  }

  private isFormValid(): boolean {
    return !!this.externalExaminer.firmName && !!this.externalExaminer.address && !!this.externalExaminer.phoneDetail.phoneNumber &&
      !!this.externalExaminer?.postCode;
  }

  private async saveEE() {
    try {
      this.submitPressed = true;
      if (!this.isFormValid()) {
        throw ('Incomplete form');
      }
      this.isSaving = true;
      const resp: any = await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(this.externalExaminer);
      this.eventCtrl.emit('show-snackbar', 'success', 'Application has been submitted');
      this.closeModal();
    } catch (err: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error: ' + err);
      this.ai.trackException('Error, Unable to save External Examiner: ' + err);
    } finally {
      this.isSaving = false;
    }
  }

}

